import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { fetchGroups, fetchedGroups } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchActionPayload = ReturnType<typeof fetchGroups>;

export function* getGroupsSaga({ meta: { callback } }: FetchActionPayload) {
  const { getGroupsList } = getAPI();
  const response: YieldOf<typeof getGroupsList> = yield call(getGroupsList);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedGroups(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedGroups(undefined, error));
  }

  if (callback) callback();
}

export default function* groupsSaga() {
  yield takeLatest(fetchGroups.type, getGroupsSaga);
}
